import React from "react";

const GridCheckbox = (props: any) => {
	return (
		<div
			className="ag-selection-checkbox"
			style={{ height: "100%", display: "flex" }}
		>
			<div className="ag-labeled ag-label-align-right ag-checkbox ag-input-field">
				<div
					className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ${
						props.value ? "ag-checked" : ""
					}`}
				>
					<input
						className="ag-input-field-input ag-checkbox-input"
						type="checkbox"
						checked={props.value}
						onChange={() => {}}
					/>
				</div>
			</div>
		</div>
	);
};

export default GridCheckbox;
